import { useEffect, useRef, useState } from 'react'
import SearchTagsObj from '@/assets/data/SearchTags.json'
import {
  setCompareTagsList,
  setCompareKeyword
} from '@/features/SetCompareTagsList/setCompareTagsList'
import { setCompareList, setCompareTotal } from '@/features/SetCompareTypeList/setCompareTypeList'
import { setKeyword, setTagsList } from '@/features/SetOverviewTagsList/setOverviewTagsList'
import * as d3 from 'd3'
import {
  setNowPage,
  setOverviewList,
  setTotal
} from '@/features/SetOverviewTypeList/setOverviewTypeList'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { getWorkListByTags, getCompareWorkListByTags, searchMind } from '@/server'
import './index.less'
import Search from 'antd/es/input/Search'
import { setToken } from '@/features/Login/login'
import { useNavigate } from 'react-router-dom'
import { RightOutlined } from '@ant-design/icons'
import { Popover } from 'antd'
import AdvancedSearch from '@/pages/IndexPage/AdvancedSearch'
import { setSearchData } from '@/features/SetSearchKey'
export interface selectedTagsI {
  主题: string[]
  朝代: string[]
  类型: string[]
  材质: string[]
  形制: string[]
  画派: string[]
}
// tag到请求数据的map
export const tag2criteria = {
  主题: 'class1',
  朝代: 'dynasty',
  类型: 'class2',
  材质: 'mediaType',
  形制: 'styleType',
  画派: 'faction'
}
interface searchBoxProps {
  selectedType: number // 浏览模式(0)/表单模式(1)/画作对比(2)
  pageType: number // 浏览页面(0)/画作对比(1)
}
export function SearchBox(props: searchBoxProps) {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const token = useAppSelector((state) => state.login.token)
  const _searchData = useAppSelector((state) => state.searchKey.searchData)
  // 缓存的tagsList和keyword
  const tagsList = useAppSelector((state) =>
    props.selectedType === 0 ? state.overviewTagsList.tagsList : state.compareTagsList.tagsList
  )
  const keyword = useAppSelector((state) =>
    props.selectedType === 0 ? state.overviewTagsList.keyword : state.compareTagsList.keyword
  )
  const tags = SearchTagsObj.tagsContent
  // 选中的tag
  const [selectedTags, setSelectedTags] = useState<selectedTagsI>(tagsList)
  // 输入框内容受控
  const [searchInputText, setSearchInputText] = useState(keyword)
  // 实际键入内容
  const [exactInputText, setExactInputText] = useState(keyword)
  // 联想框内容数组
  const [searchList, setSearchList] = useState<string[]>([])
  // 是否需要展示高亮条目
  const [activatedShowed, setActivatedShowed] = useState<boolean>(false)
  // 当前选中的搜索条目idx
  const [activatedIndex, setActivatedIndex] = useState<number>(-1)
  // 是否启用高级搜索
  const [useAdvancedSearch, setUseAdvancedSearch] = useState<boolean>(false)
  // 显示搜索框内容
  const [showInput, setShowInput] = useState<boolean>(false)
  // 浏览页面搜索回调
  const overviewFunc = (dataObj: {
    keyword: string
    criteria: { key: string; value: string[] }[]
    pages: { page: number; size: number }
  }) => {
    getWorkListByTags(token, dataObj).then((res) => {
      if (res.data.code === '10056') {
        //token失效
        window.confirm('登录已过期，请重新登录！')
        dispatch(setToken(''))
        navigate('/')
      } else {
        const list = res.data.content.list.map((item) => {
          return {
            workId: item.workid,
            workName: item.workname,
            museum: item.instname,
            mediaType: item.mediatype,
            materialType: item.materialtype,
            styleType: item.styletype,
            horizontal: item.horizontal,
            vertical: item.vertical,
            authorName: item.authorname,
            dynasty: item.dynasty,
            class1: item.class1,
            class2: item.class2,
            src: item.encoding,
            tilesPath: item.tilesPath
          }
        })
        dispatch(setTotal(res.data.content.total))
        dispatch(setOverviewList(list))
      }
    })
    //记录当前keyword和tagslist
    dispatch(setKeyword(dataObj.keyword))
    dispatch(setTagsList(JSON.parse(JSON.stringify(selectedTags))))
  }
  // 画作对比搜索回调
  const compareFunc = (dataObj: {
    keyword: string
    criteria: { key: string; value: string[] }[]
    pages: { page: number; size: number }
  }) => {
    getCompareWorkListByTags(token, dataObj).then((res) => {
      if (res.data.code === '10056') {
        //token失效
        window.confirm('登录已过期，请重新登录！')
        dispatch(setToken(''))
        navigate('/')
      } else {
        const list = res.data.content.list.map((item) => {
          return {
            workId: item.workid,
            workName: item.workname,
            museum: item.instname,
            mediaType: item.mediatype,
            materialType: item.materialtype,
            styleType: item.styletype,
            horizontal: item.horizontal,
            vertical: item.vertical,
            authorName: item.authorname,
            dynasty: item.dynasty,
            class1: item.class1,
            class2: item.class2,
            src: item.encoding,
            tilesPath: item.tilesPath
          }
        })
        dispatch(setCompareTotal(res.data.content.total))
        dispatch(setCompareList(list))
      }
    })
    //记录当前keyword和tagslist，以供点击翻页的要求
    dispatch(setCompareKeyword(dataObj.keyword))
    dispatch(setCompareTagsList(JSON.parse(JSON.stringify(selectedTags))))
  }
  // 点击列表某项及回车的回调
  function handleClick(e) {
    // 隐藏列表
    d3.select('#searchListContainer').style('display', 'none')
    setSearchInputText(e.target.innerText)
    handleSearch(e.target.innerText)
  }
  // 一页的容量
  const size = props.selectedType
    ? props.selectedType === 0
      ? 8
      : props.selectedType === 1
        ? 14
        : 6
    : 8
  // 点击搜索的回调
  const handleSearch = (e) => {
    //如果e值来源于高级搜索，则设置inputValue
    setSearchInputText(e)
    // 隐藏列表
    d3.select('#searchListContainer').style('display', 'none')
    // 重置页数为1
    dispatch(setNowPage(1))
    // 整理数据
    const dataObj: {
      keyword: string
      criteria: { key: string; value: string[] }[]
      pages: { page: number; size: number }
    } = {
      keyword: '',
      criteria: [],
      pages: {
        page: 1,
        size: size
      }
    }
    dataObj.keyword = e
    for (const key in selectedTags) {
      if (selectedTags[key].length > 0) {
        dataObj.criteria.push({ key: tag2criteria[key], value: selectedTags[key] })
      }
    }
    //保存搜索条件
    dispatch(setSearchData(dataObj))
    if (props.pageType === 0) overviewFunc(dataObj)
    else compareFunc(dataObj)
  }
  // 处理搜索框上下按键高亮搜索条目
  function handleUpDown(e) {
    // 下
    if (e.keyCode === 40) {
      if (activatedIndex === searchList.length - 1) {
        setActivatedIndex(-1)
        setSearchInputText(exactInputText)
      } else if (activatedIndex === searchList.length) {
        setActivatedIndex(0)
        setSearchInputText(searchList[0])
      } else {
        setActivatedIndex(activatedIndex + 1)
        setSearchInputText(searchList[activatedIndex + 1])
      }
    }
    // 上
    else if (e.keyCode === 38) {
      if (activatedIndex === 0) {
        setActivatedIndex(searchList.length)
        setSearchInputText(exactInputText)
      } else if (activatedIndex === -1) {
        setActivatedIndex(searchList.length - 1)
        setSearchInputText(searchList[searchList.length - 1])
      } else {
        setActivatedIndex(activatedIndex - 1)
        setSearchInputText(searchList[activatedIndex - 1])
      }
    }
  }
  // 搜索框模糊匹配防抖
  const tickRef = useRef()
  function debounce(fun, delay) {
    return function (_args) {
      //@ts-ignore
      const that = this
      clearTimeout(tickRef.current)
      //@ts-ignore
      tickRef.current = setTimeout(function () {
        fun.call(that, _args)
      }, delay)
    }
  }
  function ajax(content) {
    searchMind(
      {
        keyword: content
      },
      token
    ).then((res) => {
      setSearchList(res.data.content)
    })
  }
  const debounceAjax = debounce(ajax, 500)
  const handleChange = (e: any) => {
    d3.select('#searchListContainer').style('display', 'block')
    setExactInputText(e.target.value)
    setSearchInputText(e.target.value)
    if (e.target.value === '') {
      setSearchList([])
    } else {
      debounceAjax(e.target.value)
    }
  }
  //点击清空按钮的回调
  const handleClear = () => {
    setSelectedTags({
      主题: [],
      朝代: [],
      类型: [],
      材质: [],
      形制: [],
      画派: []
    })
  }
  //点击tag回调
  const handleClickTag = function (name: string, tag: string) {
    const newTags = JSON.parse(JSON.stringify(selectedTags))
    for (const key in newTags) {
      if (key === name) {
        //tag已经存在，则取消选择;否则更新tag
        if (newTags[name].includes(tag)) newTags[name] = newTags[name].filter((t) => t !== tag)
        else newTags[name].push(tag)
      }
    }
    setSelectedTags(newTags)
  }
  // focus搜索框的回调
  const handleFocus = function () {
    //显示搜索列表
    d3.select('#searchListContainer').style('display', 'block')
  }
  //点击搜索框列表外部，隐藏列表
  useEffect(() => {
    const func = (e: any) => {
      const searchListDiv = document.querySelector('#searchListContainer')
      if (searchListDiv && !searchListDiv.contains(e.target)) {
        d3.select('#searchListContainer').style('display', 'none')
      }
    }
    document.addEventListener('mousedown', func)
    return () => {
      document.removeEventListener('mousedown', func)
    }
  })
  return (
    <div className='search-box-container'>
      <div className='search-input'>
        <div style={{ margin: '0 0 5px 45px' }}>
          <Popover
            placement='left'
            open={useAdvancedSearch}
            content={<AdvancedSearch handleSearchKeyWord={handleSearch}></AdvancedSearch>}
          >
            <span
              onClick={() => {
                setUseAdvancedSearch(!useAdvancedSearch)
              }}
              style={{ cursor: 'pointer' }}
            >
              高级搜索
            </span>
          </Popover>

          <RightOutlined />
        </div>
        <Popover
          placement='bottom'
          title=''
          content={searchInputText}
          open={showInput && searchInputText !== ''}
        >
          <Search
            onPressEnter={(e: any) => handleSearch(e.target.value)}
            onSearch={(e) => handleSearch(e)}
            defaultValue={keyword}
            value={searchInputText}
            onChange={(e) => handleChange(e)}
            onKeyDown={(e) => {
              setActivatedShowed(true)
              handleUpDown(e)
            }}
            onFocus={handleFocus}
            onMouseOver={() => {
              setShowInput(true)
            }}
            onMouseOut={() => {
              setShowInput(false)
            }}
          />
        </Popover>
        <div
          className='search-list'
          id='searchListContainer'
          onMouseEnter={() => setActivatedShowed(true)}
          onMouseLeave={() => setActivatedShowed(false)}
        >
          {searchList.map((d, i) => (
            <div
              className={
                i === activatedIndex && activatedShowed
                  ? 'search-item search-item-activated'
                  : 'search-item'
              }
              onClick={(e) => handleClick(e)}
              onMouseOver={() => {
                setActivatedIndex(i)
              }}
            >
              {d}
            </div>
          ))}
        </div>
      </div>
      <div className='clear-btn' onClick={handleClear}>
        清空选中标签
      </div>
      <div className='search-tag'>
        <div className='tag-list'>
          {tags.map((tag, _tagIndex) => {
            return (
              <>
                <div className='tag-title'>{tag.title}</div>
                <div className='tag-content'>
                  {tag.content.map((item, _itemIndex) => {
                    if (item.includes('-'))
                      return <div className='tag-little-title'>{item.slice(0, 2)}</div>
                    else
                      return (
                        <>
                          <div
                            className={
                              selectedTags[tag.title].includes(item)
                                ? 'tag-item item-selected'
                                : 'tag-item'
                            }
                            onClick={(_e) => handleClickTag(tag.title, item)}
                          >
                            {item}
                          </div>
                        </>
                      )
                  })}
                </div>
              </>
            )
          })}
        </div>
      </div>
    </div>
  )
}
